import React from 'react';
import { Logo } from '../Logo';
import { Button } from '../ui/Button';
import { InitialAvatar } from '../InitialAvatar';
import { WORDMARK } from '../../data/registration';
import { CURRENT_MEMBER } from '../../data/community';
const GUEST_LINKS = [{
  label: 'What’s in there',
  href: '#taste'
}, {
  label: 'Your privacy',
  href: '#privacy'
}];
const MEMBER_LINKS = [{
  label: 'Explore',
  href: '#explore'
}, {
  label: 'Archive',
  href: '#archive'
}, {
  label: 'Voices',
  href: '#voices'
}];
interface SiteHeaderProps {
  mode: 'guest' | 'member';
  onStart: () => void;
  startLabel: string;
  onSignIn: () => void;
  onSignOut: () => void;
}
export function SiteHeader({
  mode,
  onStart,
  startLabel,
  onSignIn,
  onSignOut
}: SiteHeaderProps) {
  const isMember = mode === 'member';
  const links = isMember ? MEMBER_LINKS : GUEST_LINKS;
  return <header className="sticky top-0 z-30 w-full border-b border-rule bg-card" data-id="element-250" data-mp="pwni6u202xh8">
      <div className="mx-auto flex min-h-[3.5rem] w-full max-w-5xl items-center justify-between gap-4 px-4 py-2 sm:px-6" data-id="element-251" data-mp="uycs26dhl53q">
        <a href="#top" className="flex flex-col rounded-control py-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-252" data-mp="1s5bso61ji8u">
          <span className="text-heading font-semibold tracking-tight text-ink" data-id="element-253" data-mp="3o39gjxk42gla">
            We Are Stepping Stone
          </span>
          <span className="text-eyebrow-caption font-medium uppercase text-ink-muted" data-id="element-254" data-mp="kl9528fcjt2x">
            Alumni &amp; community
          </span>
        </a>

        <nav aria-label="Portal" className="hidden items-center gap-6 lg:flex" data-id="element-255" data-mp="fmem96hdq4it">
          {links.map(link => <a key={link.label} href={link.href} className="inline-flex min-h-tap items-center rounded-control text-small font-medium text-ink-muted hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-256" data-mp="asjy9quqr3dx">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-257" data-mp="2suflhdo2h6j9">
          {!isMember ? <span className="hidden items-center gap-2 md:flex" data-id="element-258" data-mp="2xqw8g4jj5eur">
              <span className="text-eyebrow-caption font-medium uppercase text-ink-muted" data-id="element-259" data-mp="2j3b7oha4nrq0">
                Hosted by
              </span>
              <span className="sr-only" data-id="element-260" data-mp="2nztcfh5gjq2c">{WORDMARK}</span>
              <Logo size="sm" aria-hidden="true" data-id="element-261" data-mp="2a1li7gzt32uv" />
            </span> : null}

          <span aria-hidden="true" className="hidden h-6 w-px bg-rule md:block" data-id="element-262" data-mp="2f1hawk31z7v4" />

          {isMember ? <>
              <span className="flex items-center gap-2" data-id="element-263" data-mp="204qiiursqwf0">
                <InitialAvatar name={CURRENT_MEMBER.fullName} size={32} data-id="element-264" data-mp="252s5vrw99hwa" />
                <span className="hidden text-small font-medium text-ink sm:inline" data-id="element-265" data-mp="254use1y78sw9">
                  {CURRENT_MEMBER.publicName}
                </span>
              </span>
              <Button variant="secondary" onClick={onSignOut} data-id="element-266" data-mp="3a3zj9obeeca">
                Sign out
              </Button>
            </> : <>
              <Button variant="secondary" onClick={onSignIn} data-id="element-267" data-mp="1iumq061cce8q">
                Sign in
              </Button>
              <Button onClick={onStart} data-id="element-268" data-mp="1xjr8zpfymmhw">{startLabel}</Button>
            </>}
        </div>
      </div>
    </header>;
}